import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-specific-block-controls',
    templateUrl: './specific-block-controls.component.html',
    styleUrls: ['./specific-block-controls.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BsDropdownModule, TooltipModule, TranslateModule],
})
export class SpecificBlockControlsComponent {
    @Input() public disableCopyEvent: boolean;
    @Input() public disableDeleteEvent: boolean;
    @Input() public selectActionTooltip: string;
    @Input() public isBlockHidden: boolean;
    @Input() public saveBlockToGallery: boolean;

    @Output() public deleteEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public copyEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public selectEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public toggleMoreActionState: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public hideBlockEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public showBlockEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public saveBlockToGalleryEvent: EventEmitter<void> = new EventEmitter<void>();

    public deleteAction(): void {
        if (this.disableDeleteEvent) {
            return;
        }

        this.deleteEvent.emit();
    }

    public copyAction(): void {
        if (this.disableCopyEvent) {
            return;
        }

        this.copyEvent.emit();
    }

    public hideBlockAction(): void {
        this.hideBlockEvent.emit();
    }

    public showBlockAction(): void {
        this.showBlockEvent.emit();
    }

    public saveBlockToLibraryAction(): void {
        this.saveBlockToGalleryEvent.emit();
    }

    public selectAction(): void {
        this.selectEvent.emit();
    }

    public isShowDropDownMenu(state): void {
        this.toggleMoreActionState.emit(state);
    }
}
